<div fxLayout="row" fxLayoutAlign="space-around center" style="width:100%;height:100%"><mat-spinner diameter="50" strokeWidth="5"></mat-spinner></div>